import { Component, Input, OnInit } from '@angular/core';
import { ILogModel } from 'src/app/models/interfaces/ILogModel';

@Component({
  selector: 'app-log-table',
  templateUrl: './log-table.component.html',
  styleUrls: ['./log-table.component.css']
})
export class LogTableComponent implements OnInit {
  @Input() listaLogModel: ILogModel[] = [];

  displayedColumns: string[] = [
    'usuario',
    'fecha',
    'comentarios',
  ];

  constructor() { 

  }

  ngOnInit(): void {
    
  }
}
